import React, { useContext } from 'react';
import { motion } from 'framer-motion';
import { secondsInPast, parentHeatsInPast } from '../../Utils/time';

import './ranking-table.scss';
import { AppContext } from '../../App';
import { Athlete } from './athlete';

const rankSort = (a, b) => {
  if (!a.rank || !b.rank || a.rank > b.rank) return 1;
  if (a.rank < b.rank) return -1;
  return 0;
};

const gateSort = (a, b) => {
  if (!a.gate || !b.gate || a.gate > b.gate) return 1;
  if (a.gate < b.gate) return -1;
  return 0;
};

const RankingTable = ({ heat, data, config }) => {
  const context = useContext(AppContext);
  const animationConfig = context.config.animation;
  const containerAnimation = {
    hidden: {
      opacity: 1,
      scale: 0,
      transition: {
        duration: animationConfig.duration,
        ease: animationConfig.ease
      }
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        when: 'beforeChildren',
        staggerChildren: 0.1,
        duration: animationConfig.duration,
        ease: animationConfig.ease
      }
    }
  };

  if (!heat || Object.keys(heat).length === 0) {
    return <>No Results selected</>;
  }

  const showResultsPast = secondsInPast(
    new Date(heat.resultIsOfficialTimestamp),
    config.delayDataSeconds || 60
  );

  heat.resultlist.sort(heat.resultIsOfficial && showResultsPast ? rankSort : gateSort);

  let showAthlets = true;

  if (data) {
    showAthlets = parentHeatsInPast(heat, data, config.delayDataSeconds || 60);
  }

  return (
    <motion.div
      className="appRow ranking"
      key={`${heat.id}`}
      variants={containerAnimation}
      initial="hidden"
      animate="visible"
    >
      <h6 className="h6">{heat.name === null || heat.name}</h6>
      <span className="ranking-status">
        {config.statusText || 'Status'}:{' '}
        {heat.resultIsOfficial && showResultsPast
          ? config.finishedText || 'finished'
          : config.upcomingText || 'upcoming'}
      </span>
      <table>
        <tbody>
          {heat &&
            showAthlets &&
            heat.resultlist &&
            heat.resultlist.map((result, index) => (
              <Athlete
                result={result}
                heat={heat}
                showResultsPast={showResultsPast}
                key={`athlete-${result.bib || result.lastname + result.rank}`}
                index={index}
                config={config}
              />
            ))}
        </tbody>
      </table>
    </motion.div>
  );
};

export { RankingTable };
